export default __webpack_public_path__ + "styles/icons/50mLBurette.svg";